import { Route } from '@angular/router';
import { Error500Component } from './shared/error-500.component';
import { Error404KnowledgebaseComponent } from './shared/error-404-knowledgebase.component';
export const appRoutes: Route[] = [
    { path: '404', component: Error404KnowledgebaseComponent },
    { path: '500', component: Error500Component },
    {
        path: '',
        loadChildren: () => import('app/modules/customer-portal/customer-portal.module').then(m => m.CustomerPortalModule)
    },
    { path: '**', redirectTo: '/404' },
];
